
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.22 20.75H5.78A2.638 2.638 0 013.25 18v-3a.75.75 0 111.5 0v3a1.16 1.16 0 001 1.25h12.47a1.16 1.16 0 001-1.25v-3a.75.75 0 111.5 0v3a2.64 2.64 0 01-2.5 2.75z"}}),_c('path',{attrs:{"d":"M12 15.75a.741.741 0 01-.53-.22l-4-4a.75.75 0 011.06-1.06L12 13.94l3.47-3.47a.75.75 0 011.06 1.06l-4 4a.738.738 0 01-.53.22z"}}),_c('path',{attrs:{"d":"M12 15.75a.76.76 0 01-.75-.75V4a.75.75 0 111.5 0v11a.76.76 0 01-.75.75z"}})])
          )
        }
      }
    